import { Injectable } from '@angular/core';

import { CompanyService } from '../../../../shared/services';
import { ExternalNavigationService } from '../../../services/external-navigation.service';

@Injectable()
export class ParnerGatewayEnabledGuard  {
  constructor(
    private companyService: CompanyService,
    private externalNavigationService: ExternalNavigationService
  ) { }

  canActivate(): boolean {
    if (this.companyService.hasOnlyPartnerGateway) {
      this.externalNavigationService.goToPartnerGateway(false);
      return false;
    }

    return true;
  }
}
